"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ArrowUp_exports = {};
__export(ArrowUp_exports, {
  default: () => ArrowUp_default
});
module.exports = __toCommonJS(ArrowUp_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.3398 5.60156V16.9102C11.3398 17.1445 11.2552 17.3464 11.0859 17.5156C10.9297 17.6719 10.7344 17.75 10.5 17.75C10.2656 17.75 10.0638 17.6719 9.89453 17.5156C9.73828 17.3464 9.66016 17.1445 9.66016 16.9102V5.60156L6.08594 9.17578C5.92969 9.33203 5.73438 9.41016 5.5 9.41016C5.26562 9.41016 5.07031 9.33203 4.91406 9.17578C4.74479 9.00651 4.66016 8.8112 4.66016 8.58984C4.66016 8.35547 4.74479 8.15365 4.91406 7.98438L9.91406 2.98438C10.0703 2.82812 10.2656 2.75 10.5 2.75C10.7344 2.75 10.9297 2.82812 11.0859 2.98438L16.0859 7.98438C16.2552 8.15365 16.3398 8.35547 16.3398 8.58984C16.3398 8.8112 16.2552 9.00651 16.0859 9.17578C15.9297 9.33203 15.7344 9.41016 15.5 9.41016C15.2656 9.41016 15.0703 9.33203 14.9141 9.17578L11.3398 5.60156Z",
      fill: "currentColor"
    }
  )
);
const SvgArrowUp = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ArrowUp_default = SvgArrowUp;
